import { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Box } from '@mui/system';
import { Alert } from '@mui/material';
import PaginationControlled from './PaginationControlled';
import CSVReport from './CSVReport';
import CSVconLLU from "./CSVconLLU";
import DictLemmata from "./dictLemmata";
import './dictLemmata.css'


export default function Lemma1({data}) {

    const [lemmaQueryInput, setLemmaQueryInput] = useState('');
    const [lemmaQueryResult, setLemmaQueryResult] = useState([]);
    const [message, setMessage] = useState('');
    const [transcription, setTranscription] = useState('dip');

    const handleChangeTranscription = (event) => {setTranscription(event.target.value)};
    function handleChange(e) {setLemmaQueryInput(e.target.value)}


    function handleSubmit(e) {
      e.preventDefault()

      let answer = []

      for (const text of data) {

        let token_index =  2
        const text_name = text['text']


        if (transcription === 'cyr') {
          token_index = 1
        } else if (transcription === 'lat') {
          token_index = 0
        }


        for (const [, sentence] of Object.entries(text['sentences'])) {

          let lemmata  = [];
          let annotations = [];
          let tokens = [];
          let UDs = [];
          let sent_plain = '';
          let translation = '';
          let sentID = null;

            let annotationsExt = [];
          let UDsOfParents = [];

            for (const word of sentence) {
                sentID = word[6]
              sent_plain += word[token_index]
              sent_plain += ' '
              tokens.push(word[token_index])
              lemmata.push(word[3])
              annotations.push(word[4])
              UDs.push(word[9]);

              UDsOfParents.push(word[8]);
              word[5] ? annotationsExt.push(word[5]) : annotationsExt.push('_');

              if (word[13]) {
                translation += word[13]
                translation += ' / '
              }

            }


           for (var i = 0; i < lemmata.length; i++) {
              if (lemmata[i] === lemmaQueryInput || lemmata[i] === lemmaQueryInput.toLowerCase()) {
             answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs, i, annotationsExt, UDsOfParents, sentID ])
            }

            }


        }
      }
      setLemmaQueryInput(lemmaQueryInput)
      setMessage(`Your query has given ${answer.length} results.`)
      setLemmaQueryResult(answer)
    }


    return (
      <Box>

<Grid container spacing={2} direction='column' >


               <Grid item xs={12} sm={6} >
         <DictLemmata setLemmaQueryInput={setLemmaQueryInput}/>
         </Grid>


         <Grid item xs={12} sm={6}>

        <select
          value={transcription}
          onChange={handleChangeTranscription}
        >
          <option value={'lat'}>Latin</option>
          <option value={'cyr'}>Cyrillic</option>
          <option value={'dip'}>Diplomatic</option>
        </select>

           </Grid>

         <Grid item xs={12} sm={6} >
         <button  type='submit'   disabled={!lemmaQueryInput} onClick={handleSubmit}>Submit</button>
         </Grid>



      </Grid>


      <Box mt={2}>

      {message && <Alert severity="info">{message}</Alert>}

      </Box>

      <CSVReport searchResult={lemmaQueryResult}   domain="lemma"/>
           <br/>
          <CSVconLLU searchResult={lemmaQueryResult} />

        <br/>

        <PaginationControlled queryResult={lemmaQueryResult} query={lemmaQueryInput} domain="lemma" trans={transcription}/>

      </Box>
    );
  }


      //  for (const lemma of lemmata) {

          //    if (lemma === lemmaQueryInput || lemma === lemmaQueryInput.toLowerCase()) {
         //       answer.push([sent_plain, text_name, tokens, lemmata, annotations, translation.slice(0, -2), UDs  ])
         //   }
        //    }
